/**
 * PositionSelectOrg 岗位选择组织弹出层 临时使用，后期应该独立成公共容器来使用
 * @author xiaohuangmaoth
 * @date 2020-01-10
 * @description 表格UI组件
 */
import React from "react";
import PropTypes from "prop-types";
import moment from 'moment';
import { utils_tool, component_tool, framework_tool } from "@/tool";
import { servingColumns } from '../columns'
const { WizContainer } = framework_tool;
const { WizDataTable, WizModalForm, WizButton } = component_tool;
import { WizTableForm } from '@/containers/common'
const { getPageData, Session } = utils_tool

class FromTable extends WizContainer {
  componentName = "FromTable";

  constructor(props) {
    super(props);
    this.state = {
      value: props.value, // 任职自定义组件传过来的value值
      visible: false, // 弹窗层状态
      record: {}, // 任职记录
      selectDisabled: true,
    };

    // 编辑时，记录上一条任职
    this.prevRecord = {};
    // 人员表单记录
    this.personDetailUpd = Session.get('personDetailUpd') || {}
    // 是否是编辑页面
    this.isUpd = location.href.includes('personDetailUpd') ? true : false
    this.flag = false
  }

  static propTypes = {
    value: PropTypes.array,
    onChange: PropTypes.func
  };


  // 生命周期钩子函数
  _componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({ value: nextProps.value });
    }
  }

  // 显示弹出表单
  showModal = (e = {}) => {
    this.flag = true
    this.setState({
      visible: true,
      ...e
    });
  };

  // 隐藏弹出表单
  hideModal = () => {
    this.setState({
      visible: false,
      record: {},
      selectDisabled: true
    });
  };

  // 提交表单
  onSubmit = (val = {}) => {
    val.hireTime = moment(val.hireTime).format('YYYY-MM-DD HH:mm') //格式化生效时间
    this.isUpd ? val.personId = this.personDetailUpd.personId : null  // 编辑时每条任职记录需带上personId
    const { onChange } = this.props;
    const { value = [], record } = this.state;
    const combineRecord = { ...val, ...record }
    const otherRecordForUpd = { jobState: val.jobState, hireTime: val.hireTime }
    const filterRecordForUpd = { ...combineRecord, ...otherRecordForUpd }
    const filterValueForUpd = value.filter(val => val.id !== this.prevRecord.id)
    const formatRecord = this.flag ? { ...combineRecord, updateTime: '', flag: true, id: Number(combineRecord.orgId + `${new Date().getTime()}` + combineRecord.positionId) } : filterRecordForUpd
    const vals = this.flag ? value : filterValueForUpd

    // 保存任职表单
    const saveSarving = () => {
      const values = [formatRecord, ...vals]
      this.setState({
        value: values, // 所有任职记录 数组
        record: {}, //当前的任职记录 
        visible: false
      });
      onChange && onChange(values); // onChange方法更新表单控件的值
    }

    // 检查是否有添加重复记录
    const checkValues = () => {
      if (!formatRecord.positionId) {
        wizNotice.error('请选择岗位')
        return false
      }
      const filterValues = vals.filter(val => val.orgId === formatRecord.orgId).filter(val => val.positionId === formatRecord.positionId)
      if (filterValues.length) {
        wizNotice.error('不可添加重复记录')
        return false
      }
      return true
    }

    checkValues() ? saveSarving() : null
  };

  // 删除行
  removeItem = (text, record) => {
    const { onChange } = this.props;
    const { value = [] } = this.state
    const filterValues = value.filter(val => val.id !== record.id)
    this.setState({
      value: filterValues
    })
    onChange && onChange(filterValues);
  }

  // 编辑行
  updateItem = (text, record) => {
    this.flag = false
    this.prevRecord = record;
    this.setState({
      record,
      visible: true,
      selectDisabled: true
    })
  }

  // 任职框选择组织后的回调
  onChangeRowMapForOrg = (rows) => {
    const row = Object.values(rows)[0] || {};
    const { record } = this.state;
    //组织改变时清除已选岗位
    if (record.orgId !== row.id && record.positionId) {
      this._onClearPosition && this._onClearPosition(false)
    }
    this.setState({
      record: { ...record, orgId: row.id, orgName: row.name, positionId: undefined, positionName: undefined }
    })
  }

  // 任职框选择岗位后的回调
  onChangeRowMapForPos = (rows) => {
    const row = Object.values(rows)[0] || {};
    const { record } = this.state;
    this.setState({
      record: { ...record, positionId: row.id, positionName: row.name }
    })
  }

  tableFormWillOpen = () => {
    const { record } = this.state;
    if (!record.orgId) {
      wizNotice.info('请先选择组织')
      return false
    }
    return true
  }

  // 任职表格操作部分渲染
  optionRender = (text, record) => {
    let comp = [
      <a onClick={() => this.updateItem(text, record)} style={{ marginRight: 15 }}>编辑</a>,
      <a onClick={() => this.removeItem(text, record)}>删除</a>
    ]
    return comp
  }

  _clearPositionForOrg = (callback) => {
    if (callback) {
      this._onClearPosition = callback
    }
  }

  _render() {
    const { value = [], visible, record, selectDisabled } = this.state;
    const showTable = value.length ? true : false;

    let positionParams = record ? { orgId: record.orgId, state: 1 } : { state: 1 }
    let other = {
      record,
      WizTableForm,
      organizationConfig: WizTableForm.Config.organization(this, { apiParams: { state: 1 } }),//组织配置
      onChangeRowMapForOrg: this.onChangeRowMapForOrg,//组织数据回调
      positionConfig: WizTableForm.Config.position(this, { apiParams: positionParams }),//岗位数据
      onChangeRowMapForPos: this.onChangeRowMapForPos,//岗位数据回调
      clearPositionForOrg: this._clearPositionForOrg,//岗位清除回调
      tableFormWillOpen: this.tableFormWillOpen,
      optionRender: this.optionRender,
      selectDisabled
    }

    const columns = servingColumns(this, other)

    const dataItems = getPageData({ records: value })

    const dataTableProps = { 
      columns, 
      rowKey: 'id', 
      dataItems,
      isScroll: true
    }

    const formProps = {
      ref: 'formRef',
      title: (this.isUpd && !this.flag ? '修改' : '添加') + '任职信息',
      // record,
      visible,
      columns,
      onCancel: () => {
        this.hideModal()
      },
      onSubmit: this.onSubmit
    };

    return (
      <React.Fragment>
        {showTable ? <WizDataTable {...dataTableProps} /> : null}
        <WizModalForm {...formProps} />
        <WizButton icon="plus" type="primary" onClick={() => this.showModal({ selectDisabled: false })} style={showTable ? { marginTop: 15 } : null}>
          添加
        </WizButton>
      </React.Fragment>
    );
  }
}

export default FromTable;
